import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  open,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-157">
      {open && <motion.div className="fixed inset-0 z-[100] flex items-end justify-center md:items-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-158">
          {/* Overlay */}
          <button type="button" aria-label="Cerrar" onClick={onClose} className="absolute inset-0 bg-wine/60 backdrop-blur-sm" data-id="element-159" />

          {/* Panel */}
          <motion.div initial={{
        y: 40,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 40,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative z-10 flex max-h-[90vh] w-full flex-col rounded-t-[16px] bg-white md:max-w-[640px] md:rounded-[16px]" data-id="element-160">
            <div className="flex items-center justify-between border-b border-pinkLight px-5 py-4 md:px-6 md:py-5" data-id="element-161">
              <h2 id="legal-modal-title" className="font-serif text-[20px] font-medium text-wine md:text-[22px]" data-id="element-162">
                {title}
              </h2>
              <button type="button" onClick={onClose} aria-label="Cerrar" className="flex h-9 w-9 items-center justify-center rounded-full text-wine transition-colors hover:bg-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-rose" data-id="element-163">
                <XIcon size={18} data-id="element-164" />
              </button>
            </div>
            <div className="overflow-y-auto px-5 py-5 md:px-6 md:py-6" data-id="element-165">
              <div className="prose-legal text-[14px] leading-relaxed text-burgundy" data-id="element-166">
                {children}
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}